import { createAuthGuard } from '@auth0/auth0-vue'
const SelectPlanEntryPoint = () => import('@/CreateAccountPlan/EntryPointSelectPlan.vue')
const PaymentInfoEntryPoint = () => import('@/CreateAccountPlan/EntryPointPaymentInfo.vue')
const PaymentSummaryEntryPoint = () => import('@/CreateAccountPlan/EntryPointPaymentSummary.vue')

// Send unauthenticated users into the purchase funnel via the Auth0 Sign Up
// flow rather than Login (mirrors the select-plan behaviour from BH-231).
// The guard auto-sets appState.target to the destination, so users return to
// their intended payment page after signing up.
const signUpGuard = createAuthGuard({
  redirectLoginOptions: {
    authorizationParams: { screen_hint: 'signup' }
  }
})

const router = [
  {
    path: '/purchase',
    name: 'purchase',
    redirect: to => {
      // Values pass through unchanged; we only rename the query keys.
      const planType = to.query.identifier
      const paymentFrequency = to.query.frequency

      // Validate against the same vocabulary EntryPointPaymentInfo expects;
      // anything else falls back to the normal select-plan screen.
      const validPlan = planType === 'wc-pro' || planType === 'wc-studio'
      const validFreq = paymentFrequency === 'Annually' || paymentFrequency === 'Monthly'
      if (!validPlan || !validFreq) {
        return { name: 'selectPlan' }
      }

      const parsedSeats = parseInt(to.query.seatCount, 10)
      const seatCount = Number.isInteger(parsedSeats) && parsedSeats > 0 ? parsedSeats : 1

      return {
        name: 'paymentInfo',
        query: { planType, paymentFrequency, seatCount }
      }
    }
  },
  {
    path: '/select-plan',
    name: 'selectPlan',
    component: SelectPlanEntryPoint,
    meta: {
      title: 'Select Plan'
    }
  },
  {
    path: '/payment-info',
    name: 'paymentInfo',
    component: PaymentInfoEntryPoint,
    beforeEnter: signUpGuard,
    meta: {
      title: 'Payment Information'
    }
  },
  {
    path: '/payment-summary',
    name: 'paymentSummary',
    component: PaymentSummaryEntryPoint,
    meta: {
      title: 'Payment Summary'
    },
    beforeEnter: (to, from) => {
      if (from.name === 'paymentInfo') {
        to.meta = {
          completedFlow: true
        }
      } else {
        to.meta = {
          completedFlow: false
        }
      }
      signUpGuard(to)
    }
  }
]

export default router
